import React from 'react';
import { SiteEvaluationState } from './useSiteEvaluation';
import VoxelLoadingSpinner from '../../../voxel/Animation/VoxelLoadingSpinner';
import VoxelTooltipShort from '../../../voxel/Tooltip/VoxelTooltipShort';
import VoxelChip, { VoxelChipProps } from '../../../voxel/Chips/VoxelChip';

export interface SiteEvaluationProps {
  domainValue: string;
  siteEvaluationState?: SiteEvaluationState;
}

export const SiteEvaluation: React.FC<SiteEvaluationProps> = ({
  domainValue,
  siteEvaluationState,
}) => {

  let siteStatusColor: VoxelChipProps["color"];
  if (siteEvaluationState?.error) siteStatusColor = 'error';
  if (siteEvaluationState?.timeout) siteStatusColor = 'info';
  if (siteEvaluationState?.status >= 200 && siteEvaluationState?.status < 300)
    siteStatusColor = 'success';
  if (siteEvaluationState?.status >= 300 && siteEvaluationState?.status < 400)
    siteStatusColor = 'info';
  if (siteEvaluationState?.status >= 400 && siteEvaluationState?.status < 500)
    siteStatusColor = 'warning';
  if (siteEvaluationState?.status >= 500) siteStatusColor = 'error';


  if (!domainValue.length) {
    return (
      <VoxelTooltipShort message={
        <div className='w-64'>
          <p>HTTP Response Status Code</p>
          <br></br>
          <p>
            Note that the result isn't always correct.
            Please double check with another source if the status code seem strange.
          </p>
        </div >
      }>
        <div className="h-[34px] w-full flex flex-row items-center justify-center text-base">
          .....
        </div>
      </VoxelTooltipShort >
    );
  }

  if (siteEvaluationState?.loading || !siteEvaluationState || siteEvaluationState?.error === undefined) {
    return (
      <div className="h-[34px] w-full flex flex-row items-center justify-center">
        <VoxelLoadingSpinner sizeClass='h-5 w-5' />
      </div>
    );
  }

  let text = '';
  if (siteEvaluationState?.error) { text = 'error' }
  if (siteEvaluationState?.timeout) { text = 'timeout' }
  if (siteEvaluationState?.status) { text = `${siteEvaluationState.status}` }

  return (
    <VoxelTooltipShort message={
      <div className='w-64'>
        <p>HTTP Response Status Code</p>
        <br></br>
        <p>
          Note that the result isn't always correct.
          Please double check with another source if the status code seem strange.
        </p>
      </div >
    }>
      <div className='h-[34px] flex flex-row items-center justify-center'>
        <VoxelChip
          title={text}
          color={siteStatusColor}
        />
      </div>
    </VoxelTooltipShort >
  );
};

export default SiteEvaluation;
